import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  Textarea,
} from '@data-delivery/d3s';
import { type UseFormReturn } from 'react-hook-form';
import { type AssignmentFormValues } from './form-schema';

interface FieldsBasicInfoProps {
  form: UseFormReturn<AssignmentFormValues>;
}

export function FieldsBasicInfo({ form }: FieldsBasicInfoProps) {
  return (
    <>
      <FormField
        control={form.control}
        name='name'
        render={({ field }) => (
          <FormItem>
            <FormLabel>Name</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name='contract'
        render={({ field }) => (
          <FormItem>
            <FormLabel>Contract</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name='description'
        render={({ field }) => (
          <FormItem className='md:col-span-2'>
            <FormLabel>Description</FormLabel>
            <FormControl>
              <Textarea rows={4} {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
}
